import { memo } from "react";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { CircularLoader } from "@similarweb/ui-components";

import { StyledIcon, StyledIconLoader } from "app/pages/activation/components/Topics/Topic/styles";

import { topIconKeys } from "../automationKeys";
import { loadingOptions } from "../constants";

type TopicIconSchema = {
    isLoading: boolean;
};

export const TopicIcon = memo(({ isLoading }: TopicIconSchema) =>
    isLoading ? (
        <StyledIconLoader data-automation={topIconKeys.preLoader}>
            <CircularLoader options={loadingOptions} />
        </StyledIconLoader>
    ) : (
        <StyledIcon data-automation={topIconKeys.icon}>
            <SWReactIcons
                iconName="keyword-group"
                size="xs"
                iconColor={colorsPalettes.carbon[400]}
            />
        </StyledIcon>
    ),
);

TopicIcon.displayName = "TopicIcon";
